<template>
  <div :style="bold ? 'font-weight: bold' : ''" class="componentfield">
    <component
      :is="`tablefield-${config.decoratorOptions.component}`"
      v-if="get(product, 'enriched.equivalenceCheckResult.state') !== 'FAILURE'"
      :config="config.decoratorOptions"
      :data="data"
      :product="product"
    ></component>
    <component
      :is="`tablefield-${config.fallback.decorator}`"
      v-else
      :config="config.fallback"
      :data="get(product, config.fallback.path)"
      :product="product"
    ></component>
  </div>
</template>

<script>
import Tablefield from "./FieldContainer"
import TablefieldText from "./FieldText.vue"
import TablefieldCombinedMultiRow from "./FieldCombinedMultirow"
import TablefieldFactsheet from "./FieldFactsheet"
import get from "lodash/get";

export default {
  name: 'tablefield-component',
  data() {
    return {
      bold: false
    }
  },
  created() {
    if (this.config.decoratorOptions.styleHints && this.config.decoratorOptions.styleHints[0] === 'heading') {
      this.config.decoratorOptions.component = 'text'
      this.bold = true
    }
  },
  methods: {get},
  components: {
    TablefieldText,
    TablefieldCombinedMultiRow,
    TablefieldFactsheet,
    Tablefield,
  },
  props: ['product', 'data', 'config'],
  computed: {}
}
</script>



// WEBPACK FOOTER //
// FieldComponent.vue?5dac1f04